"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;
exports.count = count;
var modals = [];

function add(element) {
  if (modals.indexOf(element) === -1) {
    modals.push(element);
  }
}

function remove(element) {
  var index = modals.indexOf(element);
  if (index === -1) {
    return;
  }
  modals.splice(index, 1);
}

function count() {
  return modals.length;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/helpers/refCount.js
// module id = 1247
// module chunks = 1